import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { setUserDetail } from "../../store/slices/authSlice";
import { getUserDetail } from "../../utils/helper";
import { useDispatch } from "react-redux";
import Login from "../Login";
import PrivateLayout from "../../layout";
import { Spin } from "antd";

const App = () => {
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setUserDetail(getUserDetail()));
    setLoading(false);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", padding: "32px" }}
      >
        <Spin />
      </div>
    );
  }

  return (
    <Switch>
      <Route exact={true} path="/login" component={Login} restricted={true} />
      <Route path="*" component={PrivateLayout}></Route>
    </Switch>
  );
};

export default App;
